<template>
    <div class="list">
        <NavBar></NavBar>
        <!-- 新加的测试返回通道 -->
        <!-- <van-button size="mini" type="primary" @click="openThisUrl">跳转页面之后返回问题</van-button> -->
        <!--  -->
        <div v-if="!isShow">
            <van-col span='24' style="text-align:center;font-weight:bold;font-size:20px;padding-top:7px">{{title}}</van-col>
            <van-col span='24' style="font-size:12px;color:gray;text-align:center;margin-top:7px">{{createTime}}</van-col>
            <!-- <van-col span='24' style="color: rgb(59, 58, 58);padding:10px 15px 0 15px;font-size:12px;text-indent:2em">
                {{content}}
            </van-col> -->
            <div style="padding:0 15px">
                <div v-html="content"></div>
            </div>
            <van-divider :style="{ color: 'gray', borderColor: 'gray', padding: '0 16px',fontSize:'12px',marginBottom:'70px'}">
                威海南海新区住宅维修资金宣
            </van-divider>
        </div>
        <div v-else>
            <van-empty image="error" description="加载失败..." />
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            createTime:'',
            title:'',
            content:'',
            id:'',
            isShow:false
        }
    },
    // watch:{
    //     '$route.path':function(a,b){
    //         console.log(a)
    //         if(a=='/PoliciesRegulations'){
    //             this.$router.replace('/')
    //         }
    //         console.log(b)
    //     }
    // },
    methods:{
        // 后加的测试
        // openThisUrl(){
        //     // window.location.href = 'http://127.0.0.1:8848/%E6%80%9D%E9%80%94HTML/sessions/op%E6%84%8F%E6%80%9D.html'
        //     this.$router.push({
        //         path:''
        //     })
        // },
        /**
         * 获取内容
         */
        getContent(){
            let data = {
                id:this.id
            }
            this.$postQuery('/weChatNotice/getNoticeDetailById', data).then((response) => {
                if(response.code==200){
                    this.title = response.data.title
                    this.createTime = response.data.createTime
                    this.content = response.data.content
                }else{
                    this.isShow= true
                }
                //
            })
        }
    },
    created(){
        this.id = this.$route.query.id
        this.getContent()
    }
}
</script>

<style scoped>
.list {
    margin-top: 46px;
    
}
</style>